var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprisal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9474 0.5C10.9474 0.223858 10.7235 0 10.4474 0C10.1712 0 9.94737 0.223858 9.94737 0.5C9.94737 5.71764 5.71764 9.94737 0.5 9.94737C0.223858 9.94737 0 10.1712 0 10.4474C0 10.7235 0.223858 10.9474 0.5 10.9474C5.71764 10.9474 9.94737 15.1771 9.94737 20.3947C9.94737 20.6709 10.1712 20.8947 10.4474 20.8947C10.7235 20.8947 10.9474 20.6709 10.9474 20.3947C10.9474 15.1771 15.1771 10.9474 20.3947 10.9474C20.6709 10.9474 20.8947 10.7235 20.8947 10.4474C20.8947 10.1712 20.6709 9.94737 20.3947 9.94737C15.1771 9.94737 10.9474 5.71764 10.9474 0.5ZM10.4474 3.70252C9.41984 6.89661 6.89661 9.41984 3.70252 10.4474C6.89661 11.4749 9.41984 13.9981 10.4474 17.1922C11.4749 13.9981 13.9981 11.4749 17.1922 10.4474C13.9981 9.41984 11.4749 6.8966 10.4474 3.70252Z",
    fill: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprisal);
export default __webpack_public_path__ + "static/media/Apprisal.4d2a4456757f43162680aaffa4f35642.svg";
export { ForwardRef as ReactComponent };